<!--发布任务页面  -->
<template>
  <div>
    <!-- 移动端发布任务页面 -->
    <van-pull-refresh v-if="total > 0"
                      v-model="isLoading"
                      @refresh="onRefresh">
      <van-list v-model="isRefresh"
                :finished="finished"
                finished-text="没有更多了"
                @load="GetTaskList">
        <ul class="approval-con">
          <li class="office-item"
              v-for="(item, index) of taskList"
              v-bind:key="index"
              slot="list"
              @click="DetailFun(item)">
            <img src="@/assets/infoPublic/images/blue.png"
                 class="status_icon"
                 v-show="(index)%3===0" />
            <img src="@/assets/infoPublic/images/red.png"
                 class="status_icon"
                 v-show="(index)%3===1" />
            <img src="@/assets/infoPublic/images/yellow.png"
                 class="status_icon"
                 v-show="(index)%3===2" />
            <div class="title">
              <div class="nowrap tit">{{item.PublishTaskName}}</div>
            </div>
            <p class="status">
              <span>状态:</span>
              <span v-cloak>{{item.PublishTaskStatusName}}</span>
            </p>
            <p class="task_time"
               v-cloak>{{item.LastModifyByDate}}</p>

            <i class="yd-cell-arrow detail_Btn"></i>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
    <no-data v-else
             :needBg="true"
             class="footer"></no-data>
  </div>
</template>

<script>
import NoData from '@/components/noData/Index'

export default {
  name: "PublishTake",
  components: {
    NoData
  },
  data () {
    return {
      taskList: [],
      total: 0,
      pageCurrent: 1,
      pageSize: 15, //每页显示条数,默认 xy.table.pageSize10

      isRefresh: false, // 是否加载中
      finished: false, // 加载是否完成
      isLoading: false //是否处于下拉刷新状态
    };
  },
  computed: {},
  created () {
    this.GetTaskList();
  },
  methods: {
    onRefresh () {
      setTimeout(() => {
        this.taskList = [];
        this.pageCurrent = 1;
        this.isLoading = false;
        this.GetTaskList();
      }, 500);
    },
    //获取列表数据
    async GetTaskList () {
      this.xy.loading();
      let obj = {
        PageIndex: this.pageCurrent,
        PageSize: this.pageSize,
        PublishTaskType: 0,
        PublishTaskStatus: 0,
        SearchText: "",
        BeginDate: "",
        EndDate: ""
      };
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/PublicTask/GetPublicTaskByPage`,
        obj
      );
      this.xy.unloading();
      if (res.success) {
        this.total = res.data.totalRecords;
        let _list = res.data.data;
        this.taskList = [...this.taskList, ..._list];
        this.pageCurrent++;
        this.finished = (this.taskList.length >= res.data.totalRecords) ? true : false
        this.xy.unloading();
      } else {
        this.$toast.fail(res.msg);
        this.xy.unloading();
      }
      // 加载状态结束
      this.isRefresh = false;
    },

    // 进入到详情页
    DetailFun: function (val) {
      this.$store.commit("infoPublic/setVal", val);
      this.$router.push("/home/ContentDetail");
    }
  }
};
</script>
<style lang="less" scoped>
.xy-content-module {
  width: 100%;
  padding: 20px;
  height: 90px;
}

li {
  position: relative;
}
li > p.status {
  margin: 26px 0 20px;
  font-size: 26px;
  color: #666;
}
li > p.task_time {
  font-size: 24px;
  color: #999;
}
.list {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
  margin-bottom: 16px;
  padding: 12px 30px 22px;
}

.status_icon {
  width: 8px;
  height: 46px;
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -23px;
}

.task_title,
.edit_btn,
.detail_btn {
  font-family: Hiragino Sans GB;
}

.task_status,
.task_time {
  font-family: Microsoft YaHei;
}

.task_btn {
  margin-right: 30px;
}

.task_title {
  font-size: 30px;
  font-weight: normal;
  color: rgba(17, 17, 17, 1);
}

.task_status {
  font-size: 26px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.task_time {
  font-size: 24px;
  font-weight: 300;
  color: rgba(153, 153, 153, 1);
}

.edit_btn,
.detail_btn {
  padding: 10px 35px;
  background: rgba(240, 241, 245, 1);
  border-radius: 26px;
  font-size: 26px;
  font-weight: normal;
  color: rgba(53, 56, 63, 1);
}

.detail_Btn {
  width: 48px;
  height: 48px;
  background: rgba(74, 152, 253, 1);
  box-shadow: 0px 4px 12px 0px rgba(50, 133, 255, 0.41);
  border-radius: 50%;
  text-align: center;
}
.yd-cell-arrow:after {
  display: inline-block;
  width: 48px;
  height: 48px;
  line-height: 48px;
  color: #fff !important;
  margin-left: 0 !important;
}

.edit_btn {
  margin-right: 30px;
}
.approval-con {
  padding: 20px 15px 0;
  .office-item {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
    margin-bottom: 16px;
    padding: 12px 30px 22px;
    position: relative;
    .title {
      display: flex;
      justify-content: space-between;
      .tit {
        flex: 1;
        max-width: 60%;
        font-size: 30px;
        line-height: 64px;
        color: #111;
      }
    }
    .type {
      font-size: 24px;
      color: #999;
      width: fit-content;
      height: 36px;
      line-height: 36px;
      padding: 0 20px 0 11px;
      margin-bottom: 15px;
      background: rgba(249, 249, 249, 1);
      border-radius: 14px 0px 14px 0px;
    }
    .theme {
      font-size: 28px;
      margin: 8px 0 20px;
      color: #666;
    }
    .status.pass {
      color: #21a83e;
    }
  }
}
</style>
